import * as Types from "../actionTypes/networkStateTypes";

const initialState = {
  browserOnline: true,
  socketStatus: "loading",
  reconnectAttempt: 0,
};

const networkStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SET_BROWSER_ONLINE:
      return { ...state, browserOnline: action.payload };
    case Types.SET_SOCKET_STATUS:
      return { ...state, socketStatus: action.payload };
    case Types.SET_SOCKET_RECONNECT_ATTEMPT:
      return { ...state, reconnectAttempt: action.payload };
    case Types.RESET_NETWORK_STATE:
      return initialState;
    default:
      return state;
  }
};

export default networkStateReducer;
